<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M37.333 13.333a5.333 5.333 0 11-10.666 0 5.333 5.333 0 0110.666 0zm0 37.334a5.333 5.333 0 11-10.666 0 5.333 5.333 0 0110.666 0zM32 37.333a5.333 5.333 0 100-10.666 5.333 5.333 0 000 10.666z"/></svg>